export const PRIZE_CONFIG = {
  first: { thaiText: 'รางวัลที่ 1', maxLength: 6, maxCountPrize: 1 },
  second: { thaiText: 'รางวัลที่ 2', maxLength: 6, maxCountPrize: 1 },
  third: { thaiText: 'รางวัลที่ 3', maxLength: 6, maxCountPrize: 1 },
  fourth: { thaiText: 'รางวัลที่ 4', maxLength: 6, maxCountPrize: 1 },
  fifth: { thaiText: 'รางวัลที่ 5', maxLength: 6, maxCountPrize: 1 },
  nearBy: { thaiText: 'รางวัลใกล้เคียง', maxLength: 6, maxCountPrize: 1 },
  first3Digits: {
    thaiText: 'รางวัล 3 ตัวหน้า',
    maxLength: 3,
    maxCountPrize: 1,
  },
  last3Digits: { thaiText: 'รางวัล 3 ตัวท้าย', maxLength: 3, maxCountPrize: 1 },
  last2Digits: { thaiText: 'รางวัล 2 ตัวท้าย', maxLength: 2, maxCountPrize: 1 },
}

export const PRIZE_STATES = {
  NONE: 'NONE',
  RESULT_CREATED: 'RESULT_CREATED',
  RESULT_CONFIRMED: 'RESULT_CONFIRMED',
  PRIZE_CREATED: 'PRIZE_CREATED',
  REPORT_GENERATED: 'REPORT_GENERATED',
  USER_NOTIFIED: 'USER_NOTIFIED',
}

export const PRIZE_STATES_LABEL = {
  NONE: 'ยังไม่มีผลรางวัล',
  RESULT_CREATED: 'กรอกผลรางวัล',
  RESULT_CONFIRMED: 'ยืนยันผลรางวัล',
  PRIZE_CREATED: 'สร้างผลรางวัล',
  REPORT_GENERATED: 'ออกรายงานผลรางวัล',
  USER_NOTIFIED: 'แจ้งลูกค้า',
}

export const LOADING_STATE_LABEL = {
  [PRIZE_STATES.RESULT_CONFIRMED]: 'กำลังออกผลรางวัล',
  [PRIZE_STATES.PRIZE_CREATED]: 'กำลังสร้างรายงานผลรางวัล',
}

export const PRIZE_SOURCE = {
  MANUAL: 'MANUAL',
  SANOOK: 'SANOOK',
}

export const RESULT_KEY_LIST = [
  'first',
  'second',
  'third',
  'fourth',
  'fifth',
  'nearBy',
  'first3Digits',
  'last3Digits',
  'last2Digits',
]
